import React from 'react'
import { Row, Col } from 'react-bootstrap'

const Privacy = () => (
  <Row componentClass="article">
    <Col componentClass="article" mdOffset={2} md={8} xs={12}>
      <h1>Privacy Statement</h1>
      <p>
        <font size="2">
          Thank you for your interest in CarFinder.com, LLC. (“CarFinder, we, us
          our”). We believe in being transparent with respect to the information
          that we collect and use. When we refer to CarFinder within this
          Privacy Statement, we are referring to CarFinder.com LLC. In
          references to the Site, we are referring to the web content located at
          CarFinder.com. This Privacy Statement applies to information collected
          through the CarFinder Site and does not describe the collection, use
          and disclosure practices of third parties whose websites the Site
          links. By using this Site, you acknowledge that you have read and
          agree to be bound by this statement and agree that you are subject to
          the CarFinder Terms of Service. This site is not intended for use by
          individuals under the age of 18. If you are under eighteen (18), you
          should not provide any personal information to us. You do not need to
          register to use the site. This Privacy Policy is in accordance with
          applicable law in place for the United States of America.
        </font>
      </p>

      <p>
        <strong>
          <h1>How data is being collected</h1>
        </strong>
        <strong>
          <h2>Information you provide directly to CarFinder</h2>
        </strong>
        <font size="2">
          We may collect information that you choose to provide on the site.
        </font>

        <strong>
          <h3>Direct capture</h3>
        </strong>
        <font size="2">
          When you request to be contacted by a particular car seller, Carfinder
          may directly capture your data via our contact forms on our site. That
          data may be directly forwarded to the selling dealer, or to a third
          party that maintains the relationship with the dealer. This
          information may include your name, email address, physical address,
          postal code, and telephone number, so that the seller can contact you
          to consider a car purchase.
        </font>

        <strong>
          <h3>Third party capture</h3>
        </strong>
        <font size="2">
          Your session may utilize forms that are jointly hosted by a third
          party and CarFinder. In these cases, the webaddress on your browser
          will appear as deals.carfinder.com. In those situations, the third
          party’s privacy statement will be visible and in effect. The
          information provided may include your name, email address, physical
          address, postal code, and telephone number or vehicle preferences.
          Links found on the site may route you to a dealer’s websites,
          financing providers, advertisers, partners or other service provides.
          Those links are provided as a courtesy to assist in your car buying
          experience. That activity is external to CarFinder.com and the terms
          of service for the third party will be visible and in effect.
        </font>

        <strong>
          <h2>Automatic collection of information</h2>
        </strong>
        <font size="2">
          Through various technical means, we gather information from your
          computer or handheld or mobile device when you visit the site. Some
          elements may be customized by you during your interaction with the
          site.
        </font>
        <strong>
          <h3>Browser cookies</h3>
        </strong>
        <font size="2">
          Cookies are small text files that are placed on your computer's hard
          drive by your browser to save information as you move between pages or
          websites. On your initial visit to the site, we will use Internet
          Protocol (IP) address to approximate a Zip Code. If permitted by your
          browser, the site will save your Zip Code and other search preferences
          in the cookie. This may yield unpredictable location results when
          using a VPN or a non US IP addresses.
        </font>
        <strong>
          <h3>Web logs</h3>
        </strong>
        <font size="2">
          The site uses commercially popular web hosting applications. These
          applications may automatically capture your:
          <ul>
            <li>IP address </li>
            <li>Browser and operating system used</li>
            <li>ISP or mobile carrier</li>
            <li>Type of handheld or mobile device that you used</li>
            <li>Date and time of access and the pages you visited</li>
            <li>Links used to reach the site </li>
            <li>The address of the page visited as you left the site</li>
            <li>Search terms and query criteria </li>
          </ul>
          We may utilize internally developed or commercial software to identify
          time spent on different sections on the site.
        </font>
      </p>

      <strong>
        <h2>What non personal data is being used for</h2>
      </strong>
      <font size="2">
        Information considered non personal data:
        <ul>
          <li>IP address </li>
          <li>Browser and operating system used</li>
          <li>ISP or mobile carrier</li>
          <li>Type of handheld or mobile device that you used</li>
          <li>Date and time of access and the pages you visited</li>
          <li>Links used to reach the site </li>
          <li>The address of the page visited as you left the site</li>
          <li>Search terms and query criteria </li>
        </ul>
      </font>

      <p>
        <strong>
          <h3>Analytics</h3>
        </strong>
        <font size="2">
          Your data may be used in the aggregate to identify to shopping
          patterns, regional behaviors and preferences, effectiveness of the
          site and utilization of features within the site.
        </font>
      </p>
      <p>
        <strong>
          <h3>Preferences</h3>
        </strong>
        <font size="2">
          Elements of your search criteria and location will be saved to enhance
          the user experience and prepopulate fields to avoid retyping.
        </font>
      </p>
      <p>
        <strong>
          <h3>Technical problem solving </h3>
        </strong>
        <font size="2">
          We may utilize your data to internally identify issues or deficiencies
          within the site.
        </font>
      </p>
      <p>
        <strong>
          <h2>What personal data is being used for</h2>
        </strong>
        <strong>
          <h3></h3>
        </strong>
        <font size="2">
          We use and process your personal information for a number of business
          and commercial purposes.
        </font>
      </p>
      <p>
        <strong>
          <h2></h2>
        </strong>
        <strong>
          <h3> Leads and requests</h3>
        </strong>
        <font size="2">
          If you request information via our site or a third-party extension on
          our site, you are agreeing to share that personal data with CarFinder,
          the dealer selling the vehicle, any third-party representing that
          dealer for the purpose of lead transfer. CarFinder may be compensated
          for providing this information to a dealer or third party. After the
          information is provided to third-parties, the subsequent use or
          disclosure of such information is subject to those third-parties'
          privacy policies and practices and CarFinder does not control their
          subsequent use or disclosure of information.
        </font>
      </p>
      <p>
        <strong>
          <h2></h2>
        </strong>
        <strong>
          <h3>Other uses</h3>
        </strong>
        <font size="2">
          <ul>
            <li>
              to comply with applicable legal requirements and our policies
            </li>
            <li>to diagnose and address technical problems</li>
            <li>to contact you via telephone, mail or email</li>
            <li>to follow up on any request that you have previously made</li>
            <li>
              to assist in Site administration, analysis, research, development,
              optimization and other internal purposes, including, without
              limitation, to compile usage data
            </li>
          </ul>
        </font>
      </p>

      <p>
        <strong>
          <h2>How and with whom we share you information</h2>
        </strong>
        <strong>
          <h3></h3>
        </strong>
        <font size="2">
          We do not sell or otherwise share information about you that we
          collect or receive, except as described below:
        </font>
        <strong>
          <h3> Dealers and third parties acting on behalf of dealers </h3>
        </strong>
        <font size="2">
          When you submit your e-mail address and/or phone number to a
          particular seller through the site, you agree and expressly consent to
          being contacted by the seller by various means, including by phone at
          the number provided, text message, email, automatic telephone dialing
          system and/or an artificial or prerecorded voice.
        </font>
        <strong>
          <h3> Legal authorities </h3>
        </strong>
        <font size="2">
          We cooperate with legal authorities and may in some circumstances be
          required to disclose personal information in response to requests from
          law enforcement
        </font>
        <strong>
          <h3> Advertising networks</h3>
        </strong>
        <font size="2">
          CarFinder has does not display ads from advertising networks.
        </font>
        <strong>
          <h3> Links</h3>
        </strong>
        <font size="2">
          CarFinder sites may contain links to websites not operated by us, as
          well as third party widgets and applications discussed above. Once you
          leave the CarFinder Sites, we suggest that you review the applicable
          privacy policy of the third-party website or application. We are not
          responsible for the content or use of any websites or applications
          other than on the CarFinder Sites or the privacy practices of those
          websites or applications. CarFinder may be compensated by passing your
          session to a third party via links. Non-personal data may be shared
          with the third party as part of the link. If necessary, you will have
          to reenter personal data on the third-party site, and the
          third-party’s privacy policies will be in effect when leaving
          CarFinder.
        </font>
        <strong>
          <h3>Data security</h3>
        </strong>
        <font size="2">
          We use commercially reasonable measures designed to safeguard
          information against loss, theft. unauthorized use, disclosure or
          modification. Various measures are utilized by CarFinder and the
          vendors who operate networks, hardware and software on our behalf.
        </font>

        <strong>
          <h3>Your California privacy rights</h3>
        </strong>

        <font size="2">
          CarFinder is currently not in scope of the COPR requirement
        </font>

        <strong>
          <h3> Your controls and choices</h3>
        </strong>
        <font size="2">
          If you wish for a dealer to contact you, you of course will need to
          provide a minimal amount of contact information. Most web browsers
          automatically accept cookies, but you can usually start your browser
          in a ‘privacy mode’ or explicitly decline cookies.
        </font>
        <strong>
          <h3> Disputes</h3>
        </strong>
        <font size="2">
          If you choose to visit the CarFinder Sites, your visit and any dispute
          regarding privacy is subject to this Privacy Statement and our Terms
          of Service, including limitations on damages, resolution of disputes,
          and application of the law of the state of New Jersey.
        </font>
        <strong>
          <h3>Updates to this Privacy Statement</h3>
        </strong>
        <font size="2">
          This Privacy Statement may be updated periodically to provide
          clarification or notice of changes to our practices. If we make
          changes, we will update the date at the top of this Privacy Statement
          accordingly.{' '}
        </font>
        <strong>
          <h3>How to contact us</h3>
        </strong>
        <font size="2">
          If you have any questions or comments about this Privacy Statement, or
          if you would like us to update information we have about you or your
          preferences, please contact us by email at <br></br>
        </font>
        <img
          align="left"
          title=""
          alt="email business support"
          border="0"
          src="/assets/img/cfemail_business_support.jpg"
        />
      </p>
    </Col>
  </Row>
)
export default Privacy



// WEBPACK FOOTER //
// ./src/components/Privacy.js